import { useEffect } from "react";

import { useTranslation } from "react-i18next";

import Container from "components/Container";
import Content from "components/Content";
import Header from "components/Header";
import MainMenu from "components/MainMenu";

import HeaderLogoNav from "layouts/HeaderLogoNav";

import { useSubscriptionContext } from "context/Subscription";

import ExpiredSubscription from "../ExpiredSubscription";
import NewPatient from "../NewPatient";
import SessionCard from "../SessionCard";
import StartNewSession from "../StartNewSession";

import useHomeDashboard from "./useHomeDashboard";

export default function HomeDashboard() {
  const { sessions, isLoadingSessions } = useHomeDashboard();
  const { t } = useTranslation();
  const { isActive, refetch } = useSubscriptionContext();

  useEffect(() => {
    refetch();
  }, [refetch]);

  return (
    <>
      <Header className="justify-between">
        <HeaderLogoNav />
        <MainMenu />
      </Header>
      {isActive ? (
        <Content isLoading={isLoadingSessions}>
          {sessions?.resultList && sessions.resultList.length > 0 ? (
            <Container className="p-4">
              <StartNewSession />
              <div className="pt-5 flex flex-col gap-2.5">
                <p>{t("home.dashboard.stoppedSessions")}</p>
                <div className="flex flex-col gap-2.5">
                  {sessions.resultList.map((session) => (
                    <SessionCard key={session.id} session={session} />
                  ))}
                </div>
              </div>
            </Container>
          ) : (
            <div className="flex-1 flex items-center justify-center">
              <NewPatient />
            </div>
          )}
        </Content>
      ) : (
        <ExpiredSubscription />
      )}
    </>
  );
}
